<template>
	<svg
		xmlns="http://www.w3.org/2000/svg"
		fill="currentColor"
		:width="width"
		:height="height"
		viewBox="0 0 64 64"
	>
		<path
			d="M16 20.7c0-2.6 2.1-4.7 4.7-4.7h22.6c2.6 0 4.7 2.1 4.7 4.7v16c0 2.6-2.1 4.7-4.7 4.7h-2.8v5.4c0 1-1.3 1.6-2 .7l-5.2-6.1H20.7c-2.6 0-4.7-2.1-4.7-4.7zm4.7-2.8c-1.6 0-2.8 1.3-2.8 2.8v16c0 1.6 1.3 2.8 2.8 2.8h12.9c.3 0 .7.1.9.4l4.1 4.8v-5.3h4.7c1.6 0 2.8-1.3 2.8-2.8v-16c0-1.6-1.3-2.8-2.8-2.8H20.7z"
		/>
	</svg>
</template>

<script setup lang="ts">
interface Props {
	width?: number;
	height?: number;
}
withDefaults(defineProps<Props>(), {
	width: 36,
	height: 36
});
</script>
